import { Injectable,ViewContainerRef } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ToastsManager } from './toastr/toast-manager';

// import { ToasterModule, ToasterService,   }  from 'angular2-toaster/angular2-toaster';
 
@Injectable()
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterNavigationChange = false;
    // private toasterService: ToasterService;
    
     
 
    constructor(private router: Router,public toastr: ToastsManager ) {
        // clear alert message on route change
        // router.events.subscribe(event => {
        //     if (event instanceof NavigationStart) {
        //         if (this.keepAfterNavigationChange) {
        //             // only keep for a single location change
        //             this.keepAfterNavigationChange = false;
        //         } else {
        //             // clear alert
        //             this.subject.next();
        //         }
        //     }
        // });
        // this.toasterService = toasterService;
    }
    successMsgExt(message: string,vcr: ViewContainerRef,extraParam: string){
        this.toastr.setRootViewContainerRef(vcr);
        this.toastr.success(message, extraParam,{toastLife: 3000,positionClass:'toast-top-left'});
    }
    successMsg(message: string,vcr: ViewContainerRef){
        this.toastr.setRootViewContainerRef(vcr);
        this.toastr.success(message, null,{toastLife: 3000,positionClass:'toast-top-right'});
        // this.toasterService.pop('success', 'Success Toaster', message);
    }
    errorMsg(message: string,vcr: ViewContainerRef){ 
        this.toastr.setRootViewContainerRef(vcr);
        this.toastr.error(message, null,{toastLife: 4000,positionClass:'toast-top-right'});
        // this.toasterService.pop('error', 'Error Toaster',message);
     }
 
    success(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'success', text: message });
        setTimeout(() => {
            this.subject.next();
          }, 8000);
        
        
    }
 
    error(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'error', text: message});
        setTimeout(() => {
            this.subject.next();
        }, 4000);
    }
 
    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}